import { useMutation, useQueryClient } from "@tanstack/react-query";
import { profile } from "@shared/api/services";
import { toast } from "react-toastify";

export const useSignDocs = (options = {}) => {
	const queryClient = useQueryClient();

	return useMutation({
		...options,
		mutationFn: (data) => profile.signDocs(data),
		onSuccess: (...args) => {
			toast.success("Договор-оферта подписан");
			queryClient.invalidateQueries({ queryKey: ["profile"] });
			options?.onSuccess?.(...args);
		},
	});
};
